import { Box, ButtonBase, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getEnvironmentVariable } from "../../global/environmentVariables";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

const getAppLinks = () => {
  let appLinks = {};
  if (
    getEnvironmentVariable("APP_LINKS") !== undefined &&
    getEnvironmentVariable("APP_LINKS") !== "NOT SET"
  ) {
    try {
      appLinks = JSON.parse(getEnvironmentVariable("APP_LINKS"));
    } catch (err) {}
  }
  return appLinks;
};

export default function DownloadAppPromo() {
  const { t } = useTranslation("translation", {
    keyPrefix: "pages.home"
  });

  const appLinks = getAppLinks();
  const appleLink = appLinks?.player?.apple;
  const googleLink = appLinks?.player?.google;

  if (!appleLink && !googleLink) {
    return null;
  }

  return (
      <Box sx={{ width: "100%", py: 4, backgroundColor: "action.hover" }}>
        <Container maxWidth="md" sx={{ px: [2, 3] }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} sx={{ textAlign: "center" }}>
              <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
                {t("downloadTheApp", { defaultValue: "Download the App" })}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {t("downloadTheAppDescription", {
                  defaultValue:
                    "Get the Best Coast Pairings player app to find events, check in and view pairings on the go."
                })}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap"
              }}
            >
              {appleLink && (
                <ButtonBase
                  focusRipple
                  style={{ width: "150px", maxWidth: "100%" }}
                  href={appleLink}
                  target="_blank"
                  aria-label="View app in Apple App Store."
                >
                  <span
                    style={{
                      width: "150px",
                      maxWidth: "100%",
                      height: "44px",
                      backgroundSize: "150px 44px",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/apple.png)`
                    }}
                  />
                </ButtonBase>
              )}
              {googleLink && (
                <ButtonBase
                  focusRipple
                  style={{ width: "150px", maxWidth: "100%" }}
                  href={googleLink}
                  target="_blank"
                  aria-label="View app in Google Play Store."
                >
                  <span
                    style={{
                      width: "150px",
                      maxWidth: "100%",
                      height: "44px",
                      backgroundSize: "150px 44px",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundImage: `url(${SYSTEM_IMAGES_CLOUDFRONT}/system-images/google.png)`
                    }}
                  />
                </ButtonBase>
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>
  );
}
